import React, { useContext, useState } from 'react';
import styles from "../../Components/PaymentMethodScreen/PaymentMethod.module.scss";
import { Button, Col, InputNumber, Row } from "antd";
import { FiArrowRight } from "react-icons/fi";
import { CartContext } from "../../Contexts/CartContext";

const Tips = () => {

    const cartContext = useContext(CartContext);

    const [tipAmount, setTipAmount] = useState(0);

    return (
        <div>
          {cartContext.tips > 0 ? (
                        <div
                            style={{
                                marginTop: "2rem",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <span
                                style={{
                                    fontSize: "2rem",
                                    color: "var(--color-primary)",
                                }}
                            >
                                Thanks for contribution!
                            </span>
                            <span>
                                {cartContext.tips} € Tips added with cart
                            </span>
                        </div>
                    ) : (
                        <div className={styles.tip}>
                            <img src="/icon/checkout/pm_delivery.svg" alt="" />
                            <em>Do you want to leave a tip?</em>
                            <span>
                                100% of tip goes to over delivery people.
                            </span>
                            <br />
                            <Row gutter={[15, 15]}>
                                <Col xs={8} sm={8}>
                                    <Button
                                        type="primary"
                                        ghost={tipAmount !== 1}
                                        className={styles.tip_btn}
                                        onClick={() => setTipAmount(1)}
                                    >
                                        <img
                                            src="/icon/checkout/pm_coin.svg"
                                            alt=""
                                        />
                                        <span>1 €</span>
                                    </Button>
                                </Col>
                                <Col xs={8} sm={8}>
                                    <Button
                                        type="primary"
                                        ghost={tipAmount !== 2}
                                        className={styles.tip_btn}
                                        onClick={() => setTipAmount(2)}
                                    >
                                        <img
                                            src="/icon/checkout/pm_coin.svg"
                                            alt=""
                                        />
                                        <span>2 €</span>
                                    </Button>
                                </Col>
                                <Col xs={8} sm={8}>
                                     <InputNumber
                                                style={{ width: "100px" }}
                                                placeholder={"Custom tips"}
                                                onChange={(e) =>
                                                    setTipAmount(e)
                                                }
                                            />
                                </Col>

                            </Row>
                            <br />
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "30px",
                                }}
                            >
                                <span
                                    style={{
                                        borderBottom:
                                            "1px solid var(--color-grey)",
                                    }}
                                >
                                    No Thanks
                                </span>
                                <Button
                                    type={"primary"}
                                    style={{
                                        display: "flex",
                                        gap: "10px",
                                        alignItems: "center",
                                    }}
                                    onClick={() => {
                                        if (tipAmount > 0) {
                                            cartContext.setTips(tipAmount);
                                        }
                                    }}
                                >
                                    <span
                                        style={{ color: "var(--color-light)" }}
                                    >
                                        Add a Tip
                                    </span>
                                    <FiArrowRight size={15} />
                                </Button>
                            </div>
                        </div>
                    )}
        </div>
    );
};

export default Tips;